'use strict';

const core = (() => {
    let $panel,
        $header,
        $headerItems,
        $stepItems,
        $addressStep,
        $methodStep,
        $reviewStep,
        $postalMethods,
        $paymentMethods,
        $arrows,
        $addressRadio,
        IS_GUEST = false,
        ONLY_DOWNLOADABLE = false,
        CURRENT_STEP_INDEX = 1,
        $currentHeader,
        $basket;

    const _findDomElements = () => {
        $panel = $('.js__checkout__default');
        $header = $panel.find('> div:first-child');
        $headerItems = $header.find('> div');
        $stepItems = $header.find('~ div:not(:last-child)');
        $addressStep = $stepItems.eq(1);

        if ($stepItems.length === 4) {
            $methodStep = $stepItems.eq(2);
            $reviewStep = $stepItems.eq(3);

            $postalMethods = $methodStep.find('[class^=col-]:first-child input[type=radio]');
            $paymentMethods = $methodStep.find('[class^=col-]:last-child li input[type=radio]');
        }
        else $reviewStep = $stepItems.eq(2);

        $arrows = $panel.find('> div:last-child > button[data-action]');
        $addressRadio = $addressStep.find('.js__address input[type=radio]');
        $basket = $('.js__panel-basket');
    }

    const _handleAddressOnPageLoad = () => {
        // collapse new address form
        if ($addressRadio.length == 0) $('.js__address-form').trigger('click');
        else {
            // select first address on page load
            $addressRadio.eq(0).prop('checked', true);
            $('[id$=hfSelectedAddressId]').val($addressRadio.eq(0).parent().data('id'));
        }
    }

    const _handleClickPart1 = () => {
        // ONLY_DOWNLOADABLE will be changed in basket.ts, after ajax req, based on basket content
        if (!IS_GUEST) ONLY_DOWNLOADABLE = __.core.DATA.ONLY_DOWNLOADABLE;

        if (typeof __.core.DATA.$BODY.data('current-step') !== 'undefined') CURRENT_STEP_INDEX = +__.core.DATA.$BODY.data('current-step');

        $currentHeader = $headerItems.eq(CURRENT_STEP_INDEX);

        if (ONLY_DOWNLOADABLE) $panel.addClass('only-downloadable');
        else $panel.removeClass('only-downloadable');

        if (CURRENT_STEP_INDEX == 0 && __.core.DATA.$BODY.hasClass('basket__empty')) {
            __.iAlert.alert('سبد خرید خالی است.');
            return true;
        }

        return false;
    }

    const _loadPostalPaymentMethods = callback => {
        $panel.addClass('checkout__wait');

        let cityId;
        $('.js__address').each((_, el) => {
            let $this = $(el),
                $input = $this.find('> input');

            if ($input.is(':checked')) {
                cityId = $this.next().val();
                return false;
            }
        });

        let url = __.core.DATA.API_ROOT.format('checkout', 'getpostalpaymentmethods/' + (ONLY_DOWNLOADABLE ? 0 : cityId));

        __.ajax.send(url, __.ajax.METHODS.GET, null, 'checkout').done(res => {
            $postalMethods.parent().hide();
            $paymentMethods.parent().hide();

            // postal methods
            // handle downloadable
            if (ONLY_DOWNLOADABLE) { }
            else {
                let pm = res.PostalMethods;
                $postalMethods.each((_, el) => {
                    let $this = $(el),
                        $parent = $this.parent();

                    for (let i = 0; i < pm.length; i++) {
                        if (typeof pm[i].ID !== 'undefined' && $this.val() == pm[i].ID) {
                            $parent.show();

                            $parent.children('span').remove();

                            $parent.append('<span>' + res.PostalMethods[i].FormattedPrice + ' ' + res.PostalMethods[i].PriceUnit + '</span>');
                            break;
                        }
                    }
                });
            }

            // payment methods
            for (let i in res.PaymentMethodIds) {
                $paymentMethods.each((_, el) => {
                    let $this = $(el);

                    if ($this.val() == res.PaymentMethodIds[i]) {
                        $this.parent().show();
                        return false;
                    }
                });
            }

            let $temp = $('.js__postal-methods__radio-list li:visible');
            if ($temp.length == 1) $temp.find('input').prop('checked', true).triggerHandler('change');

            let $temp2 = $('.js__payment-methods__radio-list li:visible');
            if ($temp2.length == 1) $temp2.find('input').prop('checked', true).triggerHandler('change');

            callback();

            $panel.removeClass('checkout__wait');
        });
    }

    const _initReview = () => {
        let $holders = $reviewStep.find('.js__review__holder'),
            $tds = $addressRadio.filter(':checked').closest('tr').children('td');

        // name & family
        $holders.eq(0).text($tds.eq(2).text());
        // mobile
        $holders.eq(1).text($tds.eq(3).text());
        // email
        $holders.eq(2).text($tds.eq(4).text());
        // postal code
        $holders.eq(3).text($tds.eq(6).text());
        // address
        $holders.eq(4).text($tds.eq(5).text());

        // payment method
        $holders.eq(5).text($paymentMethods ? $paymentMethods.filter(':checked').next().text() : '-');
        // postal method
        $holders.eq(6).text(
            $postalMethods
                ? `${$postalMethods.filter(':checked').next().text()} (${$postalMethods.filter(':checked').next().next().text()})`
                : '-'
        );

        let $clone = $basket.clone(false, false),
            $headerCols = $clone.find('.basket__header > .row > div');

        $clone.find('.basket__body > .row').each((i, el) => {
            let $cols = $(el).find('> div');

            $cols.last().remove();
            $cols.eq(1).removeClass('col-sm-3').addClass('col-sm-4');

            let $input = $(el).find('input');
            $input.closest('[class*=col-]').text($input.val().toString());
        });

        $headerCols.last().remove();
        $headerCols.eq(1).removeClass('col-sm-3').addClass('col-sm-4');

        $reviewStep.find('.js__panel-basket').remove();

        $reviewStep.prepend($clone);
    }

    const _validateAddressRule = () => {
        // any address is available in the list
        if ($addressRadio.length == 0) {
            __.iAlert.alert('آدرسی ثبت نشده است.');
            return false;
        }

        // any address is selected
        if ($addressRadio.filter(':checked').length == 0) {
            __.iAlert.alert('باید آدرس ارسال را انتخاب نمایید.');
            return false;
        }

        return true;
    }

    const _validateMethodRule = () => {
        // any selected postal method
        if (!ONLY_DOWNLOADABLE && $postalMethods.filter(':checked').length == 0) {
            __.iAlert.alert('انتخاب روش ارسال الزامی است.');
            return false;
        }

        // any selected payment method
        if ($paymentMethods.filter(':checked').length == 0) {
            __.iAlert.alert('انتخاب روش پرداخت الزامی است.');
            return false;
        }

        return true;
    }

    const _handleMove = i => {
        $headerItems.removeClass('step__active');
        $stepItems.removeClass('step__active');

        $headerItems.eq(i).addClass('step__active');
        $stepItems.eq(i).addClass('step__active');

        CURRENT_STEP_INDEX = i;
        $currentHeader = $headerItems.eq(CURRENT_STEP_INDEX);

        // hide back button on first step
        if (CURRENT_STEP_INDEX == 0) $arrows.eq(0).addClass('hidden');
        else $arrows.eq(0).removeClass('hidden');

        // hide next button on last step
        if (CURRENT_STEP_INDEX === $stepItems.length - 1 || $currentHeader.data('rule') === 'login-register') $arrows.eq(1).addClass('hidden');
        else $arrows.eq(1).removeClass('hidden');

        __.core.DATA.$BODY.data('current-step', CURRENT_STEP_INDEX);
    }

    const _wireEvents = () => {
        $arrows.on('click.checkout', (e) => {
            if (_handleClickPart1()) return;

            let $this = $(e.currentTarget),
                action = $this.data('action'),
                rule = $currentHeader.data('rule');

            if (action === 'next') {
                // currently basket is active and user clicked on next button
                if (rule === 'basket') {
                    console.log(ONLY_DOWNLOADABLE);

                    // in only downloadable case we need to pass second step and load postal and payment methods
                    if (ONLY_DOWNLOADABLE) _loadPostalPaymentMethods(() => _handleMove(2));
                    // otherwise just go to next step
                    else _handleMove(CURRENT_STEP_INDEX + 1);
                }
                else if (rule === 'address') {
                    // returns false if there is something invalid
                    if (!_validateAddressRule()) return;

                    // defaul mode
                    if ($headerItems.length === 5) _loadPostalPaymentMethods(() => _handleMove(CURRENT_STEP_INDEX + 1));
                    else {
                        _initReview();
                        _handleMove(CURRENT_STEP_INDEX + 1);
                    }
                }
                else if (rule === 'postal-payment') {
                    // returns false if there is something invalid
                    if (!_validateMethodRule()) return;

                    _initReview();
                    _handleMove(CURRENT_STEP_INDEX + 1);
                }
            }
            else {
                let i = CURRENT_STEP_INDEX - 1;

                // handle downloadable
                if (ONLY_DOWNLOADABLE && i == 1) i = 0;

                _handleMove(i);
            }
        });

        $paymentMethods && $paymentMethods.on('change', e => {
            let $selected = $paymentMethods.filter(':checked');

            // online
            if ($selected.val() == 3) $('.js__bank-list').removeClass('hidden');
            else $('.js__bank-list').addClass('hidden');
        });
    }

    const init = () => {
        // if (__.core.DATA.DEBUG) __.logger.log(__.logger.TYPES.INFO, 'start of init ...', 'checkout');

        _findDomElements();
        _handleAddressOnPageLoad();

        IS_GUEST = typeof $panel.data('guest') !== 'undefined';
        ONLY_DOWNLOADABLE = !IS_GUEST && typeof $panel.data('only-downloadable') !== 'undefined';
        CURRENT_STEP_INDEX = ONLY_DOWNLOADABLE ? 0 : 1;

        $stepItems.eq(CURRENT_STEP_INDEX).addClass('step__active');
        $headerItems.eq(CURRENT_STEP_INDEX).addClass('step__active');
        $currentHeader = $headerItems.eq(CURRENT_STEP_INDEX);

        // hidden next button if login/reg step is active
        if ($currentHeader.data('rule') === 'login-register') $arrows.eq(1).addClass('hidden');

        _wireEvents();

        console.log($paymentMethods);
        console.log($paymentMethods.length);

        if ($paymentMethods.length === 1) $paymentMethods.eq(0).prop('checked', true).triggerHandler('change');

        $panel.addClass('loaded');

        // if (__.core.DATA.DEBUG) __.logger.log(__.logger.TYPES.INFO, 'end of init.', 'checkout');
    };

    return {
        init
    }
})();

export default core;